import { useMemo } from 'react';
import {
  DataTableAction,
  EllipsisMenuButton,
  Menu,
  MenuContent,
  MenuTrigger,
} from '@optiaxiom/react';

import { UnifiedAgent } from '@frontend/types/agent';

type ActionsCellProps = {
  agent: UnifiedAgent;
  onCopyAgent: (agent: UnifiedAgent) => void;
  onExportAgent: (agent: UnifiedAgent) => void;
  onPublishAgent?: (agent: UnifiedAgent) => void;
  showPublishOption: boolean;
};

export const ActionsCell = ({
  agent,
  onCopyAgent,
  onExportAgent,
  onPublishAgent,
  showPublishOption,
}: ActionsCellProps) => {
  const menuOptions = useMemo(
    () => [
      {
        label: 'Duplicate Agent',
        intent: 'neutral' as const,
        execute: () => onCopyAgent(agent),
      },
      {
        label: 'Copy as JSON',
        intent: 'neutral' as const,
        execute: () => onExportAgent(agent),
      },
      ...(showPublishOption && onPublishAgent
        ? [
            {
              label: 'Publish Agent',
              intent: 'neutral' as const,
              execute: () => onPublishAgent(agent),
            },
          ]
        : []),
    ],
    [agent, onCopyAgent, onExportAgent, onPublishAgent, showPublishOption]
  );

  return (
    <Menu options={menuOptions}>
      <DataTableAction asChild visible="always">
        <MenuTrigger asChild>
          <EllipsisMenuButton appearance="subtle" aria-label="Actions" />
        </MenuTrigger>
      </DataTableAction>
      <MenuContent />
    </Menu>
  );
};
